import RegisterContainer from "./RegisterContainer";
import FormRegister from "./FormRegister";
import { Toast } from "../../components";
function Register() {
    const getError = (data) => {
        if (data) {
            Toast.open(data, "danger")
        }
    }
    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer>
                <FormRegister getError={getError} />
            </RegisterContainer>
        </>
    )
}

export default Register;